// extracted by mini-css-extract-plugin
module.exports = {"Prospect":"Styles_Prospect__3fhmn"};